import React, { useState, useEffect } from "react";
import ProfileCard from "./profile-card";
import axios from "axios";

import Header from "../common/header/Header";
import { ENDPOINTS } from "../../js/api/_config";

import { BackButton } from "../common/back-button/back-button";

const PersonalInfo = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch user profile
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await axios.get(ENDPOINTS.USER.PROFILE);
        setUserProfile(response.data.data);
        setIsLoading(false);
      } catch (error) {
        
        console.error("Error fetching user profile:", error);
        setIsLoading(false);
      }
    };

    fetchUserProfile();
  }, []);




  return (
    <>
    <Header headertitle="Profile Information"  />
    {
      isLoading?<div class="spinnerwrapper"><div class="spinner"></div></div>:<div className="main-body p-8">
      {/* Profile Card */}
      <div className="max-w-[1218px]">
      <ProfileCard
        name={`${userProfile.firstName} ${userProfile.lastName}` || "Dr. Haresh Boghara"}
        firstName={userProfile.firstName}
        lastName={userProfile.lastName}
        role={userProfile.role || ""}
        email={userProfile.email || ""}
       image={userProfile.profileImage || ""}
      />

      {/* Profile Details in Disabled Form Fields */}
      <form>
        <div className="grid grid-cols-2 gap-8 pt-8">
          {/* First Name */}
          <div>
            <label
              htmlFor="firstName"
              className="block form_label_color mb-3"
            >
              First Name <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={userProfile.firstName || "N/A"}
              disabled
              className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
            />
          </div>

          {/* Last Name */}
          <div>
            <label
              htmlFor="lastName"
              className="block form_label_color mb-3"
            >
              Last Name <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={userProfile.lastName || "N/A"}
              disabled
              className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-8 pt-8">
          {/* Phone Number */}
          <div>
            <label
              htmlFor="phoneNumber"
              className="block form_label_color mb-3"
            >
              Phone Number
            </label>
            <input
              type="text"
              id="phoneNumber"
              name="phoneNumber"
              value={userProfile.phoneNumber || "N/A"}
              disabled
              className="field_bg border_color border text-base rounded-lg block w-full p-2.5 h-12 cursor-not-allowed bg-gray-100"
            />
          </div>
          {/* Email */}
          <div>
            <label
              htmlFor="phoneNumber"
              className="block form_label_color mb-3"
            >
              Email
            </label>
            <input
              type="text"
              id="phoneNumber"
              name="phoneNumber"
              value={userProfile.email || "N/A"}
              disabled
              className="field_bg border_color border text-base rounded-lg block w-full p-2.5 h-12 cursor-not-allowed bg-gray-100"
            />
          </div>
        </div>
      </form>
      </div>
      <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-4 bottom-0 w-full -ml-8 bg-white pl-8 flex gap-5">
            <a href="/edit-personal-info"type="submit" className="btn-primary-base-bar primary_btn">
              Edit
            </a>
            <BackButton />
          </div>
    </div>
    }
    
    </>
  );
};

export default PersonalInfo;
